module.exports = __webpack_public_path__ + "6120b520b7e0f8200cccc29e6f44dcb7.fbx";